import { Component, computed, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Message, MessageService } from 'services/message/message.service';
import { AffiliateService } from '../affiliate.service';

export interface AffiliateCtaMessagePayload {
  type: 'invite' | 're-tnc';
  tncUrl: string;
  tncVersionId: string;
}

@Component({
  selector: 'app-affiliate-cta-message',
  imports: [ReactiveFormsModule],
  templateUrl: './affiliate-cta-message.component.html',
  styleUrl: './affiliate-cta-message.component.scss',
})
export class AffiliateCtaMessageComponent {
  protected message = input.required<Message>();
  protected messageType = computed(() => (this.message().payload as AffiliateCtaMessagePayload).type);

  private affiliateService = inject(AffiliateService);
  private messageService = inject(MessageService);

  async reviewAffiliateTNC() {
    await this.affiliateService.reviewAffiliateTNC();
  }

  dismiss(optOut: boolean) {
    if (optOut) {
      this.affiliateService.optOutPopups();
    }
    this.messageService.dismissMessage(this.message());
  }
}
